import UserMenu from './UserMenu.jsx';

export {UserMenu}



// WEBPACK FOOTER //
// ./components/layouts/user/menu/index.js